import getRandomValues from "./getRandomValues";
var guidEmpty = "00000000-0000-0000-0000-000000000000";
export function isGuidNullOrEmpty(guid) {
    return !guid || guid === guidEmpty;
}
// A check for RFC4122-compliant UUID version 4: https://tools.ietf.org/html/rfc4122 in a form of a string with dashes
export function isValidGuid(guid) {
    return (!isGuidNullOrEmpty(guid) &&
        /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(guid || ""));
}
export function generateGuid() {
    var randomNumbers = getRandomValues();
    var offset = 0;
    var guid = "";
    for (var i = 0; i < 36; i++) {
        switch (i) {
            case 8:
            case 13:
            case 18:
            case 23: {
                offset += 1;
                guid += "-";
                break;
            }
            case 14: {
                offset += 1;
                guid += "4";
                break;
            }
            case 19: {
                guid += ((randomNumbers[i - offset] % 4) + 8).toString(16);
                break;
            }
            default: {
                guid += (randomNumbers[i - offset] % 16).toString(16);
                break;
            }
        }
    }
    return guid;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxlQUFlLE1BQU0sbUJBQW1CLENBQUM7QUFFaEQsSUFBTSxTQUFTLEdBQVcsc0NBQXNDLENBQUM7QUFDakUsTUFBTSxVQUFVLGlCQUFpQixDQUFDLElBQStCO0lBQy9ELE9BQU8sQ0FBQyxJQUFJLElBQUksSUFBSSxLQUFLLFNBQVMsQ0FBQztBQUNyQyxDQUFDO0FBRUQsc0hBQXNIO0FBQ3RILE1BQU0sVUFBVSxXQUFXLENBQUMsSUFBK0I7SUFDekQsT0FBTyxDQUNMLENBQUMsaUJBQWlCLENBQUMsSUFBSSxDQUFDO1FBQ3hCLDRFQUE0RSxDQUFDLElBQUksQ0FDL0UsSUFBSSxJQUFJLEVBQUUsQ0FDWCxDQUNGLENBQUM7QUFDSixDQUFDO0FBRUQsTUFBTSxVQUFVLFlBQVk7SUFDMUIsSUFBTSxhQUFhLEdBQUcsZUFBZSxFQUFFLENBQUM7SUFFeEMsSUFBSSxNQUFNLEdBQUcsQ0FBQyxDQUFDO0lBQ2YsSUFBSSxJQUFJLEdBQUcsRUFBRSxDQUFDO0lBQ2QsS0FBSyxJQUFJLENBQUMsR0FBRyxDQUFDLEVBQUUsQ0FBQyxHQUFHLEVBQUUsRUFBRSxDQUFDLEVBQUUsRUFBRTtRQUMzQixRQUFRLENBQUMsRUFBRTtZQUNULEtBQUssQ0FBQyxDQUFDO1lBQ1AsS0FBSyxFQUFFLENBQUM7WUFDUixLQUFLLEVBQUUsQ0FBQztZQUNSLEtBQUssRUFBRSxDQUFDLENBQUM7Z0JBQ1AsTUFBTSxJQUFJLENBQUMsQ0FBQztnQkFDWixJQUFJLElBQUksR0FBRyxDQUFDO2dCQUNaLE1BQU07YUFDUDtZQUNELEtBQUssRUFBRSxDQUFDLENBQUM7Z0JBQ1AsTUFBTSxJQUFJLENBQUMsQ0FBQztnQkFDWixJQUFJLElBQUksR0FBRyxDQUFDO2dCQUNaLE1BQU07YUFDUDtZQUNELEtBQUssRUFBRSxDQUFDLENBQUM7Z0JBQ1AsSUFBSSxJQUFJLENBQUMsQ0FBQyxhQUFhLENBQUMsQ0FBQyxHQUFHLE1BQU0sQ0FBQyxHQUFHLENBQUMsQ0FBQyxHQUFHLENBQUMsQ0FBQyxDQUFDLFFBQVEsQ0FBQyxFQUFFLENBQUMsQ0FBQztnQkFDM0QsTUFBTTthQUNQO1lBQ0QsT0FBTyxDQUFDLENBQUM7Z0JBQ1AsSUFBSSxJQUFJLENBQUMsYUFBYSxDQUFDLENBQUMsR0FBRyxNQUFNLENBQUMsR0FBRyxFQUFFLENBQUMsQ0FBQyxRQUFRLENBQUMsRUFBRSxDQUFDLENBQUM7Z0JBQ3RELE1BQU07YUFDUDtTQUNGO0tBQ0Y7SUFFRCxPQUFPLElBQUksQ0FBQztBQUNkLENBQUMifQ==